import { LogoInUse } from './LogoInUse';
import React, { useRef, useState } from 'react';
import { Upload } from 'lucide-react';
import { Button } from '../../ui/button';

const abs = (u) => (u && u.startsWith('/') ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export const LogoField = ({ url, disabled, onUpload }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true); await onUpload(f); setBusy(false); e.target.value = '';
  };
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-4" data-testid="company-logo-field">
        <div className="w-40 h-20 border rounded-md bg-neutral-50 flex items-center justify-center overflow-hidden">
          {url ? <img src={abs(url)} alt="Company logo" className="max-w-full max-h-full object-contain" data-testid="company-logo-preview" /> : <span className="text-xs text-neutral-400">No logo</span>}
        </div>
        <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={pick} data-testid="company-logo-input" />
        <div>
          <Button size="sm" variant="outline" disabled={disabled || busy} onClick={() => ref.current?.click()} data-testid="company-logo-upload"><Upload className="w-4 h-4 mr-1" />{busy ? 'Uploading…' : url ? 'Replace logo' : 'Upload logo'}</Button>
          <p className="text-xs text-neutral-500 mt-1">PNG, JPEG or WebP, up to 2 MB.</p>
        </div>
      </div>
      <LogoInUse url={url} testId="company-logo-in-use" />
    </div>
  );
};
